import { AbstractCommand } from 'src/models/command';

class SaveAppointmentTimerFavoritesCommand extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_SaveAppointmentTimerFavorite';
	readonly processId = 'random';

	public constructor(
		id: null | number,
		appointmentRoundingMinutes: number,
		appointmentTypeId: number,
		order: number,
		title: string
	) {
		super();

		this.parameters = {
			appointmentRoundingMinutes: appointmentRoundingMinutes,
			appointmentTypeId: appointmentTypeId,
			id: id,
			order: order,
			title: title,
		};
	}
}

export { SaveAppointmentTimerFavoritesCommand };
